<template>
  <div class="item">
    <div class="child">
      <a class="subtitle" @click="show(ckey)"><div class="titledown">> {{ parentmsg.title }} </div></a>
      <div v-show="flag[ckey]" v-if="!editFlag">
      <mavon-editor
        class="replymd"
        :value="parentmsg.body"
        :subfield = "prop.subfield"
        :defaultOpen = "prop.defaultOpen"
        :toolbarsFlag = "prop.toolbarsFlag"
        :editable="prop.editable"
        :boxShadow="false"
        :scrollStyle="prop.scrollStyle"
      ></mavon-editor>

        <b-button variant="outline-primary" @click="edit(parentmsg)">编辑</b-button>

    </div>
    </div>

      <div v-if="editFlag">
        <div id="main">
          <b-input
                  class="mb-2 mr-sm-2 mb-sm-0 title"
                  placeholder="请输入标题" v-model="title"
          ></b-input>
          <mavon-editor v-model="text" ref="md" @imgAdd="upimg" style="height: 100%"/>
        </div>

        <b-button variant="outline-primary" @click="refresh(parentmsg)">更新</b-button>
        <b-button variant="outline-primary" @click="clear">取消</b-button>
      </div>
  </div>

</template>

<script>
    export default {
      name: "Replylist",
      data(){
        return {
          title:'',
          text:'',
          editFlag: false,
          key:'',
          flag:[],
       }
      },
      methods:{
        edit(parentmsg){
          this.editFlag = true
          this.title = parentmsg.title
          this.text = parentmsg.body
        },

        refresh(parentmsg){
          this.editFlag = false
          this.$set(parentmsg, "title", this.title)
          this.$set(parentmsg, "body", this.text)

          let wif = this.$store.state.password
          let author = this.$store.state.username
          let parentAuthor = parentmsg.parent_author
          let  parentPermlink = parentmsg.parent_permlink
          let permlink = parentmsg.permlink
          let title = this.title
          let body = this.text
          let jsonMetadata = parentmsg.json_metadata

          //发布到本地数据库
          //把数据拼成一个JSON
          let newpost = {
            "id": parentmsg.id,
            "title": title,
            "author": author,
            "permlink": permlink,
            "parent_author": parentAuthor,
            "parent_permlink": parentPermlink,
            "body": body,
            "created": new Date().toISOString().split('.')[0],
            "json_metadata": JSON.stringify(jsonMetadata)
          }
          this. putChapterDB(newpost)

          //发布到steem上
          this.postToSteem(wif, parentAuthor, parentPermlink, author, permlink, title, body, jsonMetadata)

        },

        putChapterDB(post){
          let db = this.$store.state.db
          const chapterName = this.$store.state.username + 'chapter'
          let transaction = db.transaction([chapterName], 'readwrite') //可读可写事务
          transaction.oncomplete = function (event) {
            console.log("533,事务操作完成")
          }
          transaction.onerror = function (event) {
            console.log("事务操作出错")
            console.dir(event)
          }
          transaction.onsuccess = function (event) {
            console.log('事务操作成功')
          }

          //从事务对象里得到表里的objectStore对象
          let objectStore = transaction.objectStore(chapterName)
          objectStore.put(post)
        },

        clear(){
          this.editFlag = false
          this.text = ''
        },

        show(key){
          //因为是下标的形式，数据不会实时渲染！
          //要使用this.$set的形式来修改它的值，这样就可以实时渲染，以实现切换的效果了。
          this.$set(this.flag, key, !this.flag[key])
         },

        upimg(pos, $file){
          this.imgEdit(pos, $file)
        }

      },

      computed: {
        prop () {
          let data = {
            subfield: false,
            defaultOpen: 'preview',
            editable: false,
            toolbarsFlag: false,
            scrollStyle: true
          }
          return data
        }
      },

      mounted(){
        for(let i=0; i<this.parentmsg.length;i++){
          this.flag[i] = false
        }
      },

      props: ['parentmsg', 'ckey']
    }
</script>

<style scoped>
  .item{
    padding: 0.2rem 0.2rem;
    margin-bottom: 0.2rem;
  }

  .child{
    display: block;

  }
  .title{
    margin-bottom: 0.5rem !important;
  }
  .subtitle{
    margin-bottom: 0.2rem;
    display: block;
  }

  .subtitle:hover{
    color: rgba(29,32,136,0.93);
    text-decoration: none;
  }

  a{
    color: rgba(55,53,58,0.75);
  }

  a:hover{
    color: rgba(29,32,136,0.93);
    text-decoration: none;

  }

  .replymd{
    min-height: auto;
    box-shadow: transparent;
  }

  .btn-outline-primary {
    color: rgba(55,53,58,0.75);
    border-color: transparent;
    font-size: 0.7rem;
  }
  .btn-outline-primary:hover{
    background-color: transparent;
    color: darkcyan;
  }
</style>
